<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e0KeFg/tc-custom/9781609451738.jpg?1718106148215" alt="This image is the cover for the book Fugitive"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fugitive
      </h1>
      <p class="bookDescription body article font2">
        <b>An extraordinary tale of life on the run from the author of the Alligator mysteries, the acclaimed crime writer with “a history as riveting as any novel” (<i>Chicago Tribune</i>).</b><br/><br/>Massimo Carlotto’s odyssey began in 1976 when, as a member of a militant leftwing organization that had fallen awry of the ruling powers, he was arrested and falsely accused of murder. Unwilling to play the role of fall guy in a political power struggle, he chose to flee the country rather than wait for a verdict that the whole country knew was a foregone conclusion. He first went into hiding in the French underworld and then made his way to a Mexico embroiled in bloody class conflict. Betrayed by a Mexican lawyer, he returned to Italy in 1985 and spent six years in prison, during which time the “Carlotto case” became Italy’s most famous legal fiasco.<br/><br/>Carlotto was finally freed with a presidential pardon in 1993. Subsequently, his case helped bring about significant changes to the Italian criminal code to ensure that similar judicial travesties would never happen again.<br/><br/><i>The Fugitive </i>is the first book that Carlotto wrote as a free man. It tells his story with verve and humor. Virtually a handbook on how to live life on the run, <i>The Fugitive</i> is also a vibrant novel full of vivid underworld characters and breathtaking moments that Carlotto recounts in the cool, lucid prose that has become his trademark.<br/><br/><b>“A gripping tale, whether read as a novel or as a memoir . . . As exciting as that other <i>Fugitive</i>, this roman a clef combines compelling crime drama with a searing portrait of a justice system gone horribly wrong.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Massimo Carlotto
      </h2>
      
      <p class="authorDescription body article"><B>Massimo Carlotto</B> was born in Padua, Italy. In addition to the many titles in his extremely popular "Alligator" series, he is also the author of <I>The Fugitive</I>, <I>Death's Dark Abyss</I>, <I>Poisonville</I>, <I>Bandit Love</I>, and <I>At the End of a Dull Day. </I>One  of Italy's most popular authors and a major exponent of the  Mediterranean Noir novel, Carlotto has been compared with many of the  most important American hardboiled crime writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4957bf9a